import { getCirugia, postCirugia } from "./ApiHIS"

export const postVigilanciaEpidemiologica=(body)=>{
    return postCirugia('cirugias/vigilancia/epideomologica',body)
}

export const postSubirArchivosVigilanciaEpidemilogica=(body)=>{
    return postCirugia('cirugias/epideomologica/subir/' + body)
}

export const postDescargarAchivosVigilanciaEpidemiologica=(body)=>{
    return getCirugia('cirugias/descargar/epideomologica',body)
}

export const postVerYDescargarPDFVigilanciaEpidemiologica=(body)=>{
    return postCirugia('cirugias/ver/epideomologica/pdf',body)
}